import AliasEqualsModel from '../../attributes/filters/AliasEqualsModel';
const attrName = 'locator.batteryAlerts';
export default AliasEqualsModel.create(attrName);